import cookie from './cookie';

const keys = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content'
];

export default function() {
  return keys.reduce( ( output, key ) => {
    const val = cookie.getItem( key );
    if ( val !== null ) {
      output[ key ] = val;
    }
    return output;
  }, {} );
}
